import { useContext } from 'react';

import { useReactionsSettings } from '@confluence/comments-hooks/entry-points/useIsReactionsEnabled.ts';

import { ReactionsContext } from './ReactionsContext.tsx';

/**
 * Resolves whether reactions are confirmed disabled for the site. Prefers the nearest
 * ReactionsProvider; surfaces outside a provider can pass a contentId to read the
 * (preloaded) site setting directly.
 */
export const useIsReactionsDisabledForSite = (contentId?: string | null): boolean => {
	const { isReactionsDisabledForSite: isDisabledFromContext } = useContext(ReactionsContext);
	const { isReactionsDisabledForSite: isDisabledForContent } = useReactionsSettings(
		contentId ?? '',
		{ skip: !contentId || isDisabledFromContext !== undefined },
	);

	return isDisabledFromContext ?? isDisabledForContent;
};
